module.exports = __webpack_public_path__ + "static/img/icon-group-1.bc5585a2.png";